<template>
  <!-- <AddButton btnname="Add New" class=" float-rights " v-if="showButton" @click="IsCreate()">
          Add New
      </AddButton>
      <EditIcon v-if="!showButton" @click="IsEditpop()">Edit</EditIcon> -->
  <Dialog v-model:visible="showDialog" :modal="true"
    :header="$t('crm.templatesetup.agentmaster.agentcreation.creation')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }" @after-hide="IsClear">
    <b-container>
      <!-- {{ assignDetails }} -->
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <div class="overall-grey mb-3">
            <div class="">{{ assignDetails.FirstName }} {{ assignDetails.LastName }}</div>
            <p>{{ assignDetails.ContactSource }}</p>
            <p class="">created on {{ moment(assignDetails.CreatedDate).format('DD-MM-YYYY') }} by {{
              assignDetails.FirstName }} {{
                assignDetails.LastName }}</p>
          </div>
        </b-row>
        <b-row>
          <b-col sm="6">
            <div class="field">
              <CustomDropdown v-model="isForm.agentName" name="Choose Agent Name" :items="Dropdownlist.assignOption"
                id="Choose Agent Name" label="Choose Agent Name" :rules="{ required: true }" :required-icon="true" />
            </div>
          </b-col>
        </b-row>
        <Footer @cancel="(showDialog = false), IsClear()" :cancelhide="false" :label="label" />
      </b-form>
    </b-container>

  </Dialog>
  <CreateSuccessully :visible="successPop" @ok="closetrigger()" />
  <EditConfirmation :editModel="editModel" @yes="IsEdit()" @no="editModel = false"
    :content="$t('confirmation.editcontent')" />
  <UpdatedSuccessfully :visible="updatePop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyExistPop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import TextFields from "../../../../components/FormComponents/TextInput.vue";
import NumberField from "../../../../components/FormComponents/InputNumber.vue";
import Textarea from "../../../../components/FormComponents/TextArea.vue";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import CreateSuccessully from "../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import LeadSourceService from "../../service/leadSource";
import AlreadyExist from "../../../../components/FormComponents/AlreadyExist.vue";
import commonService from "../../service/commonService";
import AgentService from "../../service/agentService";
import LeadService from "../../service/leadService";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import moment from 'moment';

export default defineComponent({
  props: {
    showDialog: {
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    Footer,
    TextFields,
    Textarea,
    NumberField,
    AlreadyExist,
    CustomDropdown
  },
  setup(props, { emit }) {
    debugger;
    const successPop = ref(false);
    const updatePop = ref(false);
    const alreadyExistPop = ref(false);
    const editModel = ref(false);
    const { t } = useI18n();
    const loading = ref(false);
    const { handleSubmit, errors } = useForm();
    const showDialog = ref();
    const model: any = ref(props.selectedItem);
    const label = ref(t('btn.save'));
    let localstoragedata = ref();
    let OrganizationId = ref();
    let BranchId = ref();

    const Dropdownlist = ref({
      assignByOption: [],
      assignOption: [],


    });
    onMounted(() => {
      localstoragedata.value = localStorage.getItem('UsersData')
      localstoragedata.value = JSON.parse(localstoragedata.value)
      OrganizationId.value = localstoragedata.value.OrganizationId
      BranchId.value = localstoragedata.value.BranchId
    });
    const isForm = ref({
      agentName: ref()
    });
    let assignDetails = ref({
      CreatedDate: '',
      FirstName: '',
      LastName: '',

      ContactSource: ''
    })
    const IsSubmit = handleSubmit(async (values) => {
      debugger
      emit("loadershow");
      try {

        let result = await LeadService.updateAgent(model.value.Id, isForm.value.agentName);
        let msg = result["ErrorInfo"].ErrorCode;
        if (result["result"] == "Already" && msg == null) {
          loading.value = false;
          alreadyExistPop.value = true;
        } else if (msg == null) {
          emit("loaderhide");
          // updatePop.value = true;
        }
        emit("callShow");
        showDialog.value = false

      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    });
    //findone function
    const IsEdit = async () => {
      debugger;
      loading.value = true;
      showDialog.value = true;
      try {
        debugger;
        const response = await LeadService.getById(model.value.Id);
        let data = response["result"];
        // alert(JSON.stringify(data))
        Object.keys(assignDetails.value).forEach((key) => {
          if (data[0][key]) assignDetails.value[key] = data[0][key];
        });
        loading.value = false;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    async function GetCode() {
      debugger;
      let data = {
        FormId: 2,
        HospitalId: 0,
        BranchId: 0,
      };
      let result: any = await commonService.getCodeTemplate(data);
      debugger;
      console.log(result);
      // isForm.value.Code = result;
    }


    function IsCreate() {
      showDialog.value = true;
    }
    const IsClear = () => {

      emit("update:selectedItem", undefined);
      emit("close");
    };
    //popup create
    async function IsEditpop() {
      editModel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      IsClear();
      emit("load");
      successPop.value = false;
      updatePop.value = false;
      showDialog.value = false;
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyExistPop.value = false;
    }
    async function agentList() {
      loading.value = true;
      debugger;
      try {
        const result = await AgentService.getList(OrganizationId.value);


        console.log(result);
        result["result"] = result["result"].filter((item) => item.ClientId == OrganizationId.value && item.BranchId == BranchId.value && item.IsActive == 1).map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          item.ActiveStatus = (item.IsActive == 1) ? 'Active' : 'Inactive'
          return item
        })
        Dropdownlist.value.assignOption = result["result"];
        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }
    if (model.value != null) {
      IsEdit();
      agentList();
    } else {
      IsCreate();
      GetCode();
    }
    return {
      moment,
      assignDetails,
      Dropdownlist,
      IsEditpop,
      closetrigger,
      editModel,
      updatePop,
      successPop,
      showDialog,
      IsCreate,
      IsClear,
      IsEdit,
      isForm,
      IsSubmit,
      label,
      loading,
      alreadyExistPop,
      alreadyclosetrigger
    };
  },
});
</script>